import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box, CircularProgress, ThemeProvider, CssBaseline } from '@mui/material';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SampleList from './pages/SampleList';
import SampleDetail from './pages/SampleDetail';
import CreateSample from './pages/CreateSample';
import UserManagement from './pages/UserManagement';
import DropdownManagement from './pages/DropdownManagement';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import OfflineIndicator from './components/OfflineIndicator';
import { validateToken, setInitialized } from './store/authSlice';
import { fetchSettings } from './store/settingsSlice';
import mobileTheme from './theme/mobileTheme';

const PrivateRoute = ({ children }) => {
  const { token, isInitialized } = useSelector(state => state.auth);
  
  if (!isInitialized) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  return token ? children : <Navigate to="/login" />;
};

function App() {
  const dispatch = useDispatch();
  const { token, isInitialized, loading } = useSelector(state => state.auth);

  useEffect(() => {
    if (token && !isInitialized) {
      dispatch(validateToken());
      dispatch(fetchSettings());
    } else if (!token) {
      dispatch(setInitialized());
    }
  }, [dispatch, token, isInitialized]);

  useEffect(() => {
    if (token && isInitialized) {
      dispatch(fetchSettings());
    }
  }, [dispatch, token, isInitialized]);

  if (!isInitialized || loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={mobileTheme}>
      <CssBaseline />
      <PWAInstallPrompt />
      <OfflineIndicator />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="dropdowns" element={<DropdownManagement />} />
          <Route path="samples" element={<SampleList />} />
          <Route path="create-sample" element={<CreateSample />} />
          <Route path="samples/create" element={<CreateSample />} />
          <Route path="samples/:id" element={<SampleDetail />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;